/** Loads Google Tag Manager, and only ever after the visitor opted in. */

export const GTM_ID = 'GTM-TNVXCK8';

declare const window: Window & { dataLayer?: unknown[] };

const GRANTED = {
  analytics_storage: 'granted',
  ad_storage: 'granted',
  ad_user_data: 'granted',
  ad_personalization: 'granted',
};

let loaded = false;

export const loadGtm = (): void => {
  if (typeof window === 'undefined' || loaded) return;
  loaded = true;

  const layer = (window.dataLayer = window.dataLayer || []);
  // GTM reads gtag-style commands as `arguments` objects, not arrays.
  function gtag(..._args: unknown[]) {
    // eslint-disable-next-line prefer-rest-params
    layer.push(arguments);
  }

  // Consent Mode v2: declare the default, then the grant, before any tag can fire.
  gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
  gtag('consent', 'update', GRANTED);

  layer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
};
